import { Box, Link } from '@miro-site/core';
import React from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PreviewMode = function PreviewMode(props) {
  var _props$stopPreviewPat = props.stopPreviewPath,
      stopPreviewPath = _props$stopPreviewPat === void 0 ? '/api/stop-preview' : _props$stopPreviewPat;
  return /*#__PURE__*/_jsxs(PreviewModeWrapper, {
    $p: 12,
    children: ["Preview mode is enabled.\xA0", /*#__PURE__*/_jsx(Link, {
      $variant: "default",
      $color: "pink",
      href: stopPreviewPath,
      title: "Exit preview",
      children: "Click here"
    }), "\xA0 to stop."]
  });
};

var PreviewModeWrapper = styled(Box).withConfig({
  displayName: "PreviewMode__PreviewModeWrapper",
  componentId: "sc-60ikh0-0"
})(["position:fixed;bottom:0;width:100%;z-index:9999;background-color:", ";text-align:center;color:", ";"], function (props) {
  return props.theme.colors.primaryIndigo;
}, function (props) {
  return props.theme.colors.primaryWhite;
});
export default PreviewMode;